import { render, staticRenderFns } from "./NursingWatchList.vue?vue&type=template&id=06f9504f&scoped=true"
import script from "./NursingWatchList.vue?vue&type=script&lang=js"
export * from "./NursingWatchList.vue?vue&type=script&lang=js"
import style0 from "./NursingWatchList.vue?vue&type=style&index=0&id=06f9504f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f9504f",
  null
  
)

export default component.exports